/* eslint-disable */
import * as React from "react";

import { TextField } from "@material-ui/core";
import { MessageDescriptor, useIntl } from "react-intl";
import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";
import { messages } from "./SubscriptionsSettings.messages";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputLabel: {
      color: theme.palette.primary.main,
    },
    helperText: {
      position: "absolute",
      bottom: "-22px",
      color: "#f44336",
    },
    textField: {
      position: "relative",
      maxWidth: 700,
    },
    errorTypo: {
      color: "#f44336",
    },
  })
);

type SubscriptionsSettingsNameProps = {
  value: string;
  onChange: (value: string) => void;
  error?: MessageDescriptor;
};

export const SubscriptionsSettingsName: React.FC<SubscriptionsSettingsNameProps> = (props: SubscriptionsSettingsNameProps) => {
  const { value, onChange, error } = props;
  const { formatMessage } = useIntl();
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <TextField
      variant="outlined"
      margin="normal"
      fullWidth
      label={formatMessage(messages.subscriptionName)}
      value={value}
      onChange={handleChange}
      InputLabelProps={{ classes: { root: classes.inputLabel } }}
      FormHelperTextProps={{ classes: { root: classes.helperText } }}
      error={!!error}
      helperText={error && formatMessage(error)}
      classes={{ root: classes.textField }}
    />
  );
};
